import { FC, useEffect } from 'react';
import { $Formutil, connect } from 'react-bootstrap-formutil';
import Skeleton from 'components/base/Skeleton';
import ErrorBox from 'components/ErrorBox';
import { language } from 'utils/i18n';
import ContactPersonList, { ContactPersonListProps } from './ContactPersonList';
import { useGetContactList } from './hook';
import { TrustedContactPersonFormutil } from './type';

interface TrustedContactPersonProps extends Pick<ContactPersonListProps, 'onAdd' | 'onEdit'> {
    $formutil: $Formutil<TrustedContactPersonFormutil>;
}

const TrustedContactPerson: FC<TrustedContactPersonProps> = ({ $formutil, ...restProps }) => {
    const { $setValues } = $formutil;
    const { data, isLoading, error, mutate } = useGetContactList();

    useEffect(() => {
        if (data && data.items) {
            // 接口数据更新时重新设置值。目前添加联络人的途径有多个，比如bos、个人中心
            $setValues({
                temporaryContactPerson: data.items
            });
        }
    }, [data, $setValues]);

    return (
        <div className="trusted-contact-person-root mb-4">
            <h3 className="open-title">{__('Trusted Contact Person')}</h3>
            <p className="normal-text-color mb-0">
                {__(
                    'A trusted contact person, who must be at least 18 years old, is someone you designate that TradeUP Securities may contact in case of emergency or incapacity.'
                )}
            </p>
            <a
                className="mb-3 d-inline-block"
                href={`https://www.tradeup.com/help/detail?parentId=22&contentId=47&lang=${language}`}
                target="_blank">
                {__('Why do we need this information?')}
            </a>
            {!data && error ? (
                <ErrorBox error={error} onClick={() => mutate()} />
            ) : isLoading ? (
                <Skeleton line={2} />
            ) : (
                <ContactPersonList {...restProps} refresh={mutate} $defaultValue={data?.items ?? []} />
            )}
        </div>
    );
};

export default connect(TrustedContactPerson);
export { default as TrustedContactContent } from './ContactPersonContent';
export * from './type';
export * from './hook';
